"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcCardProductV2Behavior = void 0;
var default_behavior_1 = require("../../../common/models/default-behavior");
var common_constants_1 = require("../../../common/constants/common-constants");
var helpers_1 = require("../../../common/helpers");
var helpers_2 = require("../../../common/helpers");
var helpers_3 = require("../../../common/helpers");
var bc_card_product_v2_constants_1 = require("./bc-card-product-v2-constants");
var bc_card_product_v2_constants_2 = require("./bc-card-product-v2-constants");
var bc_card_product_v2_constants_3 = require("./bc-card-product-v2-constants");
var bc_card_product_v2_constants_4 = require("./bc-card-product-v2-constants");
var bc_card_product_v2_constants_5 = require("./bc-card-product-v2-constants");
var bc_card_product_v2_constants_6 = require("./bc-card-product-v2-constants");
var bc_card_product_v2_constants_7 = require("./bc-card-product-v2-constants");
var bc_card_product_v2_constants_8 = require("./bc-card-product-v2-constants");
var bc_card_product_v2_constants_9 = require("./bc-card-product-v2-constants");
var bc_card_product_v2_constants_10 = require("./bc-card-product-v2-constants");
var bc_card_product_v2_constants_11 = require("./bc-card-product-v2-constants");
var bc_card_product_v2_constants_12 = require("./bc-card-product-v2-constants");
var bc_card_product_v2_constants_13 = require("./bc-card-product-v2-constants");
var bc_card_product_v2_constants_14 = require("./bc-card-product-v2-constants");
var bc_card_product_v2_constants_15 = require("./bc-card-product-v2-constants");
var bc_card_product_v2_constants_16 = require("./bc-card-product-v2-constants");
var bc_card_product_v2_constants_17 = require("./bc-card-product-v2-constants");
var BcCardProductV2Behavior = (function (_super) {
    __extends(BcCardProductV2Behavior, _super);
    function BcCardProductV2Behavior() {
        var _this = _super.call(this) || this;
        _this.toggleIcon = null;
        _this.config = null;
        _this.style = {};
        _this.active = false;
        _this.cardBody = null;
        _this.onceToggleAction = false;
        return _this;
    }
    BcCardProductV2Behavior.prototype._setUp = function () {
        this.getElements();
        this.setEventListeners();
    };
    BcCardProductV2Behavior.prototype.build = function () {
        this.isReady = false;
        this.bodySectionBuilder();
        this.cardHeadBuilder();
        this.cardDescriptionsBuilder();
        this.cardInfoContainerBuilder();
        this.cardTitleBalanceBuilder();
        this.cardStausBuilder();
        this.cardBalanceBuilder();
        this.cardAddtionalText();
        switch (this.config.typeIcon) {
            case 'pictograms':
                this.imgSectionBuilder();
                break;
            case 'illustrations':
                this.imgSectionBuilder();
                break;
            case 'strokes':
                this.imgSectionBuilder();
                break;
            case 'logos':
                this.imgSectionBuilder();
                break;
            case 'icons':
                this.iconSectionBuilder();
                break;
            case 'funcionales':
                this.iconSectionBuilder();
                break;
            default:
                break;
        }
        this.isReady = true;
    };
    BcCardProductV2Behavior.prototype.setActive = function (status) {
        this.active = status;
        if (status) {
            (0, helpers_1.replaceClass)(this.toggleIcon, bc_card_product_v2_constants_10.CARD_TOGGLE_CLASS_V2, bc_card_product_v2_constants_11.CARD_TOGGLE_ACTIVE_CLASS_V2);
        }
        else {
            (0, helpers_1.replaceClass)(this.toggleIcon, bc_card_product_v2_constants_11.CARD_TOGGLE_ACTIVE_CLASS_V2, bc_card_product_v2_constants_10.CARD_TOGGLE_CLASS_V2);
        }
    };
    BcCardProductV2Behavior.prototype.setConfig = function (config) {
        this.config = config;
        this.style = this.config.style ? this.config.style : {};
        this.initConfiguration();
        this.getType();
    };
    BcCardProductV2Behavior.prototype.getConfig = function () {
        this.getType();
        this.getIconConfig();
        this.getSutittleConfig();
        this.getTitleBalanceConfig();
        this.getStatusConfig();
        this.getBalanceConfig();
        this.getAdditionalTextConfig();
        if (this.toggleIcon) {
            this.config.icon = this.toggleIcon;
        }
        return this.config;
    };
    BcCardProductV2Behavior.prototype.initConfiguration = function () {
        if (!this.config) {
            this.config = {
                value: new Date().getMilliseconds(),
                tittle: this.getCardTittle(),
            };
        }
    };
    BcCardProductV2Behavior.prototype.getElements = function () {
        this.getToggle();
        this.getCardBody();
    };
    BcCardProductV2Behavior.prototype.getCardTittle = function () {
        var tittle = this.mySelf.querySelector("*[class~='".concat(bc_card_product_v2_constants_9.CARD_TITLE_CLASS, "']"));
        if (tittle) {
            return tittle.innerHTML;
        }
        return "";
    };
    BcCardProductV2Behavior.prototype.getCardBody = function () {
        var bodyContainer = this.mySelf.querySelector("*[class~='".concat(bc_card_product_v2_constants_7.CARD_BODY_CLASS_V2, "']"));
        if (bodyContainer) {
            this.cardBody = bodyContainer;
        }
    };
    BcCardProductV2Behavior.prototype.getToggle = function () {
        var toggleIcon = this.mySelf.querySelector(".".concat(bc_card_product_v2_constants_10.CARD_TOGGLE_CLASS_V2, ", .").concat(bc_card_product_v2_constants_11.CARD_TOGGLE_ACTIVE_CLASS_V2));
        if (toggleIcon) {
            this.toggleIcon = toggleIcon;
        }
    };
    BcCardProductV2Behavior.prototype.getType = function () {
        if (!this.config) {
            this.initConfiguration();
        }
    };
    BcCardProductV2Behavior.prototype.setEventListeners = function () {
        var _this = this;
        if (this.toggleIcon && this.toggleAction) {
            var eventClick = function (e) {
                if (_this.disabled) {
                    return;
                }
                _this.toggleAction(e);
                e.target.setAttribute('listener', 'true');
            };
            if (this.toggleIcon.getAttribute('listener') !== 'true') {
                this.toggleIcon.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, eventClick);
                (0, helpers_3.addFocusable)(this.toggleIcon, {}, { event: this.toggleAction });
            }
        }
        if (this.clickAction) {
            this.mySelf.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function (event) {
                if (_this.disabled) {
                    return;
                }
                _this.clickAction(event);
            });
        }
    };
    BcCardProductV2Behavior.prototype.cardTitleBalanceBuilder = function () {
        var titleBalanceClass = [];
        titleBalanceClass.push(bc_card_product_v2_constants_1.CARD_SUBTITLE_BALANCE_CLASS);
        if (this.style.titleBalanceStyle) {
            this.style.titleBalanceStyle.forEach(function (element) {
                titleBalanceClass.push(element);
            });
        }
        if (this.config.titleBalance) {
            this.infoDivAppend((0, helpers_2.createElement)({
                element: common_constants_1.BcCommonConstants.P_TAG,
                classList: titleBalanceClass,
                innerText: this.config.titleBalance,
            }));
        }
    };
    BcCardProductV2Behavior.prototype.cardAddtionalText = function () {
        var infoAditionalTextClass = this.setArrayStyles('additionalTextStyle', bc_card_product_v2_constants_17.CARD_INFO_ADITIOAL_TEXT_CLASS_V2);
        if (this.config.additionalText) {
            this.infoDivAppend((0, helpers_2.createElement)({
                element: common_constants_1.BcCommonConstants.P_TAG,
                classList: infoAditionalTextClass,
                innerText: this.config.additionalText,
            }));
        }
    };
    BcCardProductV2Behavior.prototype.cardBalanceBuilder = function () {
        if (!this.config.balance) {
            return false;
        }
        var infoBalanceClass = this.setArrayStyles('balanceStyle', bc_card_product_v2_constants_16.CARD_INFO_BALANCE_CLASS_V2);
        var infoBalanceDecimalClass = this.setArrayStyles('balanceDecimalStyle', bc_card_product_v2_constants_1.CARD_INFO_BALANCE_DECIMAL_CLASS);
        var balanceSplit = this.config.balance.split(',');
        var balance = [
            (0, helpers_2.createElement)({
                element: common_constants_1.BcCommonConstants.SPAN_TAG,
                classList: infoBalanceClass,
                innerText: balanceSplit[0],
            }),
            (0, helpers_2.createElement)({
                element: common_constants_1.BcCommonConstants.SPAN_TAG,
                classList: infoBalanceDecimalClass,
                innerText: balanceSplit[1] ? ',' + balanceSplit[1] : ''
            })
        ];
        this.infoDivAppend((0, helpers_2.createElement)({
            element: common_constants_1.BcCommonConstants.DIV_TAG,
            children: balance
        }));
    };
    BcCardProductV2Behavior.prototype.setArrayStyles = function (param, defaultClass, secondDefaultClass) {
        var arrayClass = [];
        arrayClass.push(defaultClass);
        if (secondDefaultClass) {
            arrayClass.push(secondDefaultClass);
        }
        if (this.style[param]) {
            this.style[param].forEach(function (element) {
                arrayClass.push(element);
            });
        }
        return arrayClass;
    };
    BcCardProductV2Behavior.prototype.cardStausBuilder = function () {
        if (this.config.statusComponentText) {
            var elementsStatus = void 0;
            var classIconStatus = void 0;
            var classIconBorder = void 0;
            if (this.config.statusComponentIcon && this.config.statusComponentIconPosition == 'left') {
                elementsStatus = this.createIconLeft();
                classIconStatus = bc_card_product_v2_constants_3.STATUS_ICON_LEFT_CLASS_V2;
            }
            else if (this.config.statusComponentIcon && this.config.statusComponentIconPosition == 'right') {
                elementsStatus = this.createIconRight();
                classIconStatus = bc_card_product_v2_constants_4.STATUS_ICON_RIGHT_CLASS_V2;
            }
            else {
                elementsStatus = this.createIconDefault();
                classIconStatus = bc_card_product_v2_constants_1.STATUS_WITOUT_ICON_CLASS;
            }
            var classColorStatus = bc_card_product_v2_constants_1.STATUS_COLOR_CLASS + '-' + this.config.statusComponentColor;
            if (this.config.statusComponentIconBorderPosition == 'left') {
                classIconBorder = bc_card_product_v2_constants_1.STATUS_ICON_BORDER_RIGHT_CLASS;
            }
            else if (this.config.statusComponentIconBorderPosition == 'right') {
                classIconBorder = bc_card_product_v2_constants_1.STATUS_ICON_BORDER_LEFT_CLASS;
            }
            else {
                classIconBorder = bc_card_product_v2_constants_1.STATUS_ICON_BORDER_CENTER_CLASS;
            }
            var classesStatus = this.setArrayStyles('statusStyle', bc_card_product_v2_constants_2.STATUS_CLASS_V2);
            classesStatus.push(classColorStatus);
            classesStatus.push(classIconStatus);
            classesStatus.push(classIconBorder);
            var status_1 = (0, helpers_2.createElement)({
                element: common_constants_1.BcCommonConstants.DIV_TAG,
                classList: classesStatus,
                children: elementsStatus
            });
            this.infoDivAppend(status_1);
        }
    };
    BcCardProductV2Behavior.prototype.createIconLeft = function () {
        return [
            (0, helpers_2.createElement)({
                element: common_constants_1.BcCommonConstants.I_TAG,
                classList: [common_constants_1.BcCommonConstants.ICONS_CLASS, common_constants_1.BcCommonConstants.ICON_SM_CLASS],
                innerText: this.config.statusComponentIcon
            }),
            (0, helpers_2.createElement)({
                element: common_constants_1.BcCommonConstants.SPAN_TAG,
                innerText: this.config.statusComponentText
            }),
        ];
    };
    BcCardProductV2Behavior.prototype.createIconRight = function () {
        return [
            (0, helpers_2.createElement)({
                element: common_constants_1.BcCommonConstants.SPAN_TAG,
                innerText: this.config.statusComponentText
            }),
            (0, helpers_2.createElement)({
                element: common_constants_1.BcCommonConstants.I_TAG,
                classList: [common_constants_1.BcCommonConstants.ICONS_CLASS, common_constants_1.BcCommonConstants.ICON_SM_CLASS],
                innerText: this.config.statusComponentIcon
            }),
        ];
    };
    BcCardProductV2Behavior.prototype.createIconDefault = function () {
        return [
            (0, helpers_2.createElement)({
                element: common_constants_1.BcCommonConstants.SPAN_TAG,
                innerText: this.config.statusComponentText
            })
        ];
    };
    BcCardProductV2Behavior.prototype.infoDivAppend = function (element) {
        var infoDIv = this.cardBody.querySelector("*[class~='".concat(bc_card_product_v2_constants_15.CARD_INFO_CLASS_V2, "']"));
        if (infoDIv) {
            infoDIv.appendChild(element);
        }
    };
    BcCardProductV2Behavior.prototype.cardInfoContainerBuilder = function () {
        var divInfo = (0, helpers_2.createElement)({
            element: common_constants_1.BcCommonConstants.DIV_TAG,
            classList: [bc_card_product_v2_constants_15.CARD_INFO_CLASS_V2],
        });
        if (this.cardBody) {
            this.cardBody.appendChild(divInfo);
        }
    };
    BcCardProductV2Behavior.prototype.cardDescriptionsBuilder = function () {
        var bodyContainer = this.mySelf.querySelector("*[class~='".concat(bc_card_product_v2_constants_7.CARD_BODY_CLASS_V2, "']"));
        var subTitleClass = this.setArrayStyles('subtitleStyle', bc_card_product_v2_constants_13.CARD_SUBTITLE_CLASS);
        var subTitleDescriptionClass = this.setArrayStyles('subtitleDescriptionStyle', bc_card_product_v2_constants_14.CARD_SUBTITLE_DESCRIPTION_CLASS);
        if (!bodyContainer) {
            return;
        }
        var subtittle = (0, helpers_2.createElement)({
            element: common_constants_1.BcCommonConstants.P_TAG,
            classList: subTitleClass,
        });
        var subtittleDescription = (0, helpers_2.createElement)({
            element: common_constants_1.BcCommonConstants.P_TAG,
            classList: subTitleDescriptionClass,
        });
        var details = this.config.subtittle;
        if (!details) {
            return;
        }
        if (!Array.isArray(details)) {
            subtittle.innerText = details;
        }
        else {
            if (details[0]) {
                subtittle.innerText = details[0];
            }
            if (details[1]) {
                subtittleDescription.innerText = details[1];
            }
        }
        bodyContainer.appendChild(subtittle);
        bodyContainer.appendChild(subtittleDescription);
    };
    BcCardProductV2Behavior.prototype.cardHeadBuilder = function () {
        var classesTittle = this.setArrayStyles('titleStyle', bc_card_product_v2_constants_9.CARD_TITLE_CLASS);
        if (this.cardBody) {
            var head = (0, helpers_2.createElement)({
                element: common_constants_1.BcCommonConstants.DIV_TAG,
                classList: [bc_card_product_v2_constants_8.CARD_HEAD_CLASS_V2],
                children: [
                    (0, helpers_2.createElement)({
                        element: common_constants_1.BcCommonConstants.P_TAG,
                        classList: classesTittle,
                        innerText: this.config.tittle,
                    }),
                ]
            });
            var toggle = this.config.toggleIcon || (0, helpers_2.createElement)({
                element: common_constants_1.BcCommonConstants.EM_TAG,
                classList: [
                    this.active ?
                        bc_card_product_v2_constants_11.CARD_TOGGLE_ACTIVE_CLASS_V2 :
                        bc_card_product_v2_constants_10.CARD_TOGGLE_CLASS_V2,
                    common_constants_1.BcCommonConstants.ICONS_CLASS,
                    bc_card_product_v2_constants_12.CARD_TOGGLE_ACTIVE_DIRECTION_CLASS_V2
                ],
                props: {
                    'aria-hidden': 'true',
                },
            });
            this.toggleIcon = toggle;
            head.appendChild(toggle);
            this.cardBody.appendChild(head);
        }
    };
    BcCardProductV2Behavior.prototype.iconSectionBuilder = function () {
        var iconSectionClass = this.setArrayStyles('iconStyle', common_constants_1.BcCommonConstants.ICONS_CLASS, bc_card_product_v2_constants_5.CARD_ICON_LEADING_ICON_CLASS_V2);
        var iconSection = (0, helpers_2.createElement)({
            element: common_constants_1.BcCommonConstants.DIV_TAG,
            classList: [bc_card_product_v2_constants_5.CARD_ICON_LEADING_ICON_CLASS_V2],
            children: [
                (0, helpers_2.createElement)({
                    element: common_constants_1.BcCommonConstants.EM_TAG,
                    classList: iconSectionClass,
                    props: {
                        'aria-hidden': 'true',
                    },
                    innerText: this.config.icon || 'e-card'
                })
            ]
        });
        this.mySelf.prepend(iconSection);
    };
    BcCardProductV2Behavior.prototype.imgSectionBuilder = function () {
        var srcBancolombiaDesignSystem = "https://library-sdb.apps.bancolombia.com/bds/6.50.0/assets/icons/".concat(this.config.typeIcon, "/").concat(this.config.icon, ".svg");
        var imgSectionClass = this.setArrayStyles('iconStyle', common_constants_1.BcCommonConstants.ICONS_CLASS);
        var imgSection = (0, helpers_2.createElement)({
            element: common_constants_1.BcCommonConstants.DIV_TAG,
            classList: [bc_card_product_v2_constants_6.CARD_ICON_LEADING_IMG_CLASS_V2],
            children: [
                (0, helpers_2.createElement)({
                    element: common_constants_1.BcCommonConstants.IMG_TAG,
                    classList: imgSectionClass,
                    props: {
                        'alt': this.config.icon,
                        'src': srcBancolombiaDesignSystem
                    },
                })
            ]
        });
        this.mySelf.prepend(imgSection);
    };
    BcCardProductV2Behavior.prototype.bodySectionBuilder = function () {
        var bodyContainer = (0, helpers_2.createElement)({
            element: common_constants_1.BcCommonConstants.DIV_TAG,
            classList: [bc_card_product_v2_constants_7.CARD_BODY_CLASS_V2],
        });
        this.mySelf.appendChild(bodyContainer);
        this.getCardBody();
    };
    BcCardProductV2Behavior.prototype.getIconConfig = function () {
        var iconClass = bc_card_product_v2_constants_5.CARD_ICON_LEADING_ICON_CLASS_V2;
        var icon = this.mySelf.querySelector("div.".concat(iconClass, " > em"));
        if (icon) {
            this.config.icon = icon;
        }
    };
    BcCardProductV2Behavior.prototype.getSutittleConfig = function () {
        var subtittle = this.cardBody.querySelector("*[class~='".concat(bc_card_product_v2_constants_13.CARD_SUBTITLE_CLASS, "']"));
        var subtittleDescription = this.cardBody.querySelector("*[class~='".concat(bc_card_product_v2_constants_14.CARD_SUBTITLE_DESCRIPTION_CLASS, "']"));
        if (subtittle) {
            this.config.subtittle = subtittle.innerHTML;
            if (subtittleDescription) {
                this.config.subtittle = [subtittle.innerHTML, subtittleDescription.innerHTML];
            }
        }
    };
    BcCardProductV2Behavior.prototype.getStatusConfig = function () {
        var statusDiv = this.cardBody.querySelector("".concat(common_constants_1.BcCommonConstants.DIV_TAG, ".").concat(bc_card_product_v2_constants_2.STATUS_CLASS_V2));
        if (statusDiv) {
            var list = statusDiv.classList.value;
            this.config.statusComponentClassList = list.split(" ");
            var statusText = statusDiv.querySelector(common_constants_1.BcCommonConstants.SPAN_TAG);
            if (statusText) {
                this.config.statusComponentText = statusText.innerHTML;
            }
            var statusIcon = statusDiv.querySelector(".".concat(common_constants_1.BcCommonConstants.ICONS_CLASS));
            if (statusIcon) {
                this.config.statusComponentIcon = statusIcon.innerHTML;
            }
        }
    };
    BcCardProductV2Behavior.prototype.getBalanceConfig = function () {
        var balance = this.cardBody.querySelector("*[class~='".concat(bc_card_product_v2_constants_16.CARD_INFO_BALANCE_CLASS_V2, "']"));
        if (balance) {
            this.config.balance = balance.innerHTML;
        }
    };
    BcCardProductV2Behavior.prototype.getTitleBalanceConfig = function () {
        var titleBalance = this.cardBody.querySelector("*[class~='".concat(bc_card_product_v2_constants_1.CARD_INFO_TITLE_BALANCE_CLASS_V2, "']"));
        if (titleBalance) {
            this.config.titleBalance = titleBalance.innerHTML;
        }
    };
    BcCardProductV2Behavior.prototype.getAdditionalTextConfig = function () {
        var additionalText = this.cardBody.querySelector("*[class~='".concat(bc_card_product_v2_constants_17.CARD_INFO_ADITIOAL_TEXT_CLASS_V2, "']"));
        if (additionalText) {
            this.config.additionalText = additionalText.innerHTML;
        }
    };
    return BcCardProductV2Behavior;
}(default_behavior_1.BcDefaultBehavior));
exports.BcCardProductV2Behavior = BcCardProductV2Behavior;
